import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=332df50e&"
var script = {}
import style0 from "./Card.vue?vue&type=style&index=0&id=332df50e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports